import React from 'react';
import { cn } from '../../utils/cn';

const TONES = {
    on: 'bg-primary-600',
    off: 'bg-surface-emphasis',
    thumb: 'bg-surface',
    focus: 'focus-visible:ring-focus',
};

/**
 * On/off toggle (role="switch") for every boolean setting.
 * @param {boolean} checked
 * @param {(next: boolean) => void} onChange
 * @param {string} label accessible name (the visible label usually sits beside it)
 * @param {boolean} [disabled]
 */
export function Switch({ checked, onChange, label, disabled }) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={!!checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => onChange(!checked)}
            className={cn(
                'relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:opacity-40',
                TONES.focus,
                checked ? TONES.on : TONES.off
            )}
        >
            <span
                className={cn(
                    'pointer-events-none inline-block h-4 w-4 transform rounded-full shadow-sm transition duration-200',
                    TONES.thumb,
                    checked ? 'translate-x-4' : 'translate-x-0'
                )}
            />
        </button>
    );
}
